import { Station } from '@app/core/types/stations';
import {
  filterAdoverlayData,
  formatAdoverlayData,
  formatAdoverlayForMarker,
} from '@app/modules/logger/screens/stream/components/audit/adoverlay/utils';
import {
  PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum,
  PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum,
  PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum,
  pntSegmentsControllerGetSegmentAdOverlayByDateQueryKey,
  usePntSegmentsControllerGetSegmentAdOverlayByDate,
} from '@mi-front/api-v2';
import { DateTimeStr, TimeRange } from '@mi-front/core';
import { isAdOverlayEnabled } from '../../../helpers';

const adOverlayQueryParams = (range: TimeRange<DateTimeStr>) => ({
  from: range.from,
  to: range.to,
  withResults: PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum.true,
  sortBy: PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum.date,
  sortOrder: PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum.desc,
});

/**
 * Fetches ad overlay detections for a station time range and formats them as stream markers.
 */
export function useAdOverlayMatches(station: Station, range: TimeRange<DateTimeStr>) {
  const params = adOverlayQueryParams(range);

  return usePntSegmentsControllerGetSegmentAdOverlayByDate(station.slug, params, {
    query: {
      enabled: isAdOverlayEnabled(station),
      select: (results) =>
        formatAdoverlayForMarker(formatAdoverlayData(filterAdoverlayData(results))),
    },
  });
}

useAdOverlayMatches.queryKey = (station: Station, range: TimeRange<DateTimeStr>) =>
  pntSegmentsControllerGetSegmentAdOverlayByDateQueryKey(station.slug, adOverlayQueryParams(range));
